import { useState } from 'react';
// import Slider from "react-slick";
// import gsap from "gsap";
// import { useGSAP } from "@gsap/react";
import Lenis from 'lenis'

import Header from '../components/header'
import Footer from '../components/footer'
import ProductFilter from "../components/ProductFilter";
import MakeAppoinment from '../components/make-appoinment';


const accordionData = [
{
id:1,
title:"System Design",
content:"Custom system design tailors refrigeration layouts to specific loads, incorporating ammonia or CO2 cycles for optimal performance in cold storage facilities. Engineers perform heat load calculations and select components like compressors and evaporators for scalability. Detailed CAD models and simulations validate designs before implementation.[4][5]"
},
{
id:2,
title:"Validation & Testing",
content:"Commissioning and validation verify system performance through pressure tests, leak detection, and capacity trials to meet industry standards. Functional testing ensures controls, sensors, and safety interlocks operate seamlessly under load. Documentation supports regulatory approvals for food safety and environmental compliance.[5][2]"
},
{
id:3,
title:"Energy Audits",
content:"Comprehensive audits analyze energy consumption, identifying inefficiencies in compressors, defrost cycles, and insulation for targeted improvements. Infrared scans and data logging reveal heat losses, with recommendations for VFD retrofits or natural refrigerant upgrades. Post-audit reports quantify ROI on optimizations, often achieving 20-30% savings.[5][2]"
},
{
id:4,
title:"Project Consulting",
content:"Consulting guides feasibility studies, budgeting, and contractor selection for new installations or retrofits in industrial plants. Risk assessments cover safety protocols for ammonia handling and phased implementation to avoid production halts. Ongoing advisory ensures alignment with emerging regulations like F-Gas reductions.[6][7]"
},
{
id:5,
title:"Maintenance Planning",
content:"Preventive maintenance programs schedule inspections, refrigerant analysis, and component replacements to extend system life. Predictive tools like vibration monitoring prevent failures in critical evaporators and pumps. Tailored contracts provide 24/7 support for minimal disruptions in continuous operations."
}
]

function Supportservices() {
    const [openSections, setOpenSections] = useState({ 1: true });

  const toggleSection = (id) => {
    setOpenSections((prev) => ({
      ...prev,
      [id]: !prev[id]
    }));
  };

  
     const lenis = new Lenis({
    duration: 2.2,
    easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)), 
    direction: 'vertical', // vertical, horizontal
    gestureDirection: 'vertical', // vertical, horizontal, both
    smooth: true,
    mouseMultiplier: 1,
    smoothTouch: true,
    touchMultiplier: 2,
    infinite: false,
  })


  function raf(time) {
    lenis.raf(time)
    requestAnimationFrame(raf)
    }
    
    requestAnimationFrame(raf)

    //  var settings = {
    //     dots: true,
    //     infinite: true,
    //     speed: 500,
    //     slidesToShow: 1,
    //     slidesToScroll: 1,
    //     // initialSlide: 0,
    //     autoplay: true,
    //     autoplaySpeed: 2000,
       
    //   };

    
    return(
      <section id="smooth-wrapper">
          <Header/>
          <main>
          {/* <!--Start breadcrumb area-->      */}
{/* <section className="breadcrumb-area">
	<div className="container text-center">
		<h1>Support Services</h1>
	</div>
</section> */}
{/* <!--End breadcrumb area--> */}

{/* <!--Start breadcrumb bottom area--> */}
{/* <section className="breadcrumb-botton-area">
    <div className="container">
        <div className="left">
            <ul>
                <li><a href="/">Home</a></li>
                <li><i className="fa fa-caret-right" aria-hidden="true"></i></li>
                <li><a href="services.html">Services</a></li>
                <li><i className="fa fa-caret-right" aria-hidden="true"></i></li>
                <li className="active">Support Services</li>
            </ul>    
        </div>
    </div>
</section> */}
{/* <!--End breadcrumb bottom area--> */}

{/* <!--Start service single area--> */}
<section id="service-single-area">
    <div className="container">
        <div className="row">
            <ProductFilter/>
            <div className="col-lg-9 col-md-8 col-sm-12 col-xs-12 pull-right">
                <div className="service-single-content">
                    {/* <!--Start top content --> */}
                    <div className="row top-content">
                        <div className="col-md-5 col-sm-12 col-xs-12 flex-image-middle">
                             {/* <Slider {...settings}>
                                <img src="assets/images/about/about-us.jpg" alt="Awesome Image"/>
                                <img src="assets/images/about/about-us.jpg" alt="Awesome Image"/>
                                <img src="assets/images/about/about-us.jpg" alt="Awesome Image"/>
                            </Slider> */}
                             <img src="assets/images/OurProducts/Supervising-722x368.jpg" alt="Supervising-722x368.jpg"/>
                        </div>
                        <div className="col-md-7 col-sm-12 col-xs-12">
                            <div className="textholder">
                                <div className="sec-title">
                                    <h1><span>Support Services</span></h1>
                                </div>
                                <div className="text">
                                    {/* <span>We Are professional. Reliable and Affortable</span> */}
                                    <p className="top">
                                        Refrigeration engineering services deliver expert support for designing, optimizing, and maintaining industrial systems to ensure efficiency, compliance, and reliability in sectors like food processing. These services encompass system design, audits, validation, and consulting to minimize downtime and energy costs
                                    </p>

                                     <div className="single-sidebar">
                                                <a href="assets/indusref-refpak-brochure.pdf" className='single-pdf'>
                                                    <div className="icon-holder download">
                                                        <span className="flaticon-pdf-file-format-symbol"></span>    
                                                    
                                                    </div>
                                                    <div className="title-holder">
                                                        <h5>Download Here!</h5>    
                                                    </div>
                                                </a>
                                    </div> 
                                    {/* <p>Who has any right to find fault with a man who chooses to enjoy a pleasure that has no annoying consequences, or one who avoids a annoying consequences resultant pleasure.</p> */}
                                </div>
                                
                            </div>
                        </div>
                    </div>
                    {/* <!--End top content --> */}
                    <div className="row">
                        <div className="col-md-12">
                            <div className="border"></div>
                        </div>
                    </div>
                    {/* <!--Start middle content--> */}
                    <div className="row middle-content">
                        <div className="col-md-7">
                            <div className="text-holder">
                               <div className="title">
                                    <h2>Sub-categories</h2>
                                </div>
                                <div className="text">
                                    {/* <p>Don't spend time and money on beautiful landscaping if you have not taken water and irrigation issues into account first. Installing a sprinkler system, leveling the ground.</p> */}
                                    <ul>
                                         {accordionData.map(({title}) => (
                                        <li><i className="fa fa-arrow-circle-o-right" aria-hidden="true"></i>{title}</li>
                                         ))}
                                    </ul>
                                </div>
                            </div>
                        </div>
                        {/* <div className="col-md-5">
                              <Slider {...settings}>
                                <img src="assets/images/about/about-us.jpg" alt="Awesome Image"/>
                                <img src="assets/images/about/about-us.jpg" alt="Awesome Image"/>
                                <img src="assets/images/about/about-us.jpg" alt="Awesome Image"/>
                            </Slider>
                        </div> */}
                    </div>
                    {/* <!--End middle content--> */}
                     {/* <!--Start bottom content--> */}
                              <div className="row bottom-content">
                                    <div className="col-md-12">
                                        <div className="title">
                                                <h2>Sub-category Descriptions</h2>
                                            </div>
                                        <div className="accordion-box">
                                            {accordionData.map(({ id, title, content }) => (
                                            <>
                                            {/* <!--Start single accordion box--> */}
                                            <div className="accordion accordion-block" key={id}>
                                                <div className={`accord-btn ${openSections[id] ? 'active' : ''}`} onClick={() => toggleSection(id)}><h4>{title}</h4></div>
                                                {openSections[id] && (
                                                <div className="accord-content collapsed">
                                                    <p>
                                                    {content}
                                                    </p>
                                                </div>
                                                )}
                                            </div>
                                            {/* <!--End single accordion box-->  */}
                                            </>
                                            ))}
                                    </div>
                                </div>
                                </div>
                    {/* <!--End bottom content--> */}
                    {/* <!--Start Consultation form--> */}
                     <MakeAppoinment/>
                    {/* <!--End Consultation form--> */}
                </div>
            </div>
         
            
        </div>
    </div>    
</section>
{/* <!--End service single area--> */}

          </main>
          <Footer/>
      </section>
    )
 }
 
 export default Supportservices;


